import React from 'react';

const ItemCard = ({ item, onSelect, states }) => {
    const handleClick = () => {
        onSelect(item.id);
    };

    return (
        <div className=" border p-0 rounded-lg overflow-hidden cursor-pointer" onClick={handleClick} title={item.name}>
            <div className="card-body p-0">
                <div className=''>
                    {item && item.image ? (
                        <img className='mx-auto w-full h-32 object-cover'  src={item.image} alt={item.name} />
                    ) : (
                    <img className='mx-auto w-full h-32 object-cover'  src='/wp-content/plugins/devs-accounting/src/img/placeholder.jpg' />
                    )}
                </div>
                <div className="px-3 p-0">
                    <div className="mb-0 pt-2 font-bold text-gray-800">{item.name}</div>
                    <h4 className='text-blue-600 pt-2 mb-2'>${states ==='bill'? item.purchase_price : item.sale_price}</h4>
                </div>
            </div>
        </div>
    );
};

export default ItemCard;
